import { Box, Card, Stack, Text, Title } from '@mantine/core';

const FacebookAudienceInfo = ({ statuses }) => {
  return (
    <Card withBorder p="sm">
      <Title order={6} mb="sm">Audience Details</Title>
      <Stack gap={2}>
        <Text size="sm">
          <strong>Audience ID:</strong> {statuses.audience.info.id}
        </Text>
        <Text size="sm">
          <strong>Approx. Size:</strong>{' '}
          {statuses.audience.info.approximate_count_lower_bound ===
          statuses.audience.info.approximate_count_upper_bound
            ? statuses.audience.info.approximate_count_lower_bound
            : `${statuses.audience.info.approximate_count_lower_bound} - ${statuses.audience.info.approximate_count_upper_bound}`}
        </Text>
        <Text size="sm">
          <strong>Delivery Status:</strong> {statuses.audience.info.delivery_status?.description ?? 'UNKNOWN'}{' '}
          (Code: {statuses.audience.info.delivery_status?.code ?? 'N/A'})
        </Text>
        <Text size="sm">
          <strong>Operation Status:</strong> {statuses.audience.info.operation_status?.description ?? 'UNKNOWN'}{' '}
          (Code: {statuses.audience.info.operation_status?.code ?? 'N/A'})
        </Text>
      </Stack>
    </Card>
  );
};

export default FacebookAudienceInfo;
